import React, { useState } from 'react';
import axios from 'axios';
import './AdminBackup.css';
import AdminMenu from '../components/AdminMenu';

function AdminBackup() {
  const [archivo, setArchivo] = useState(null);
  const [mensaje, setMensaje] = useState('');
  const [cargando, setCargando] = useState(false);

  const descargarBackup = async () => {
    try {
      setCargando(true);
      const response = await axios.get('https://mundiemby.us.to/api/backup', {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const enlace = document.createElement('a');
      enlace.href = url;

      const nombreArchivo = response.headers['content-disposition']
        ?.split('filename=')[1]
        ?.replaceAll('"', '') || 'backup.sql';

      enlace.setAttribute('download', nombreArchivo);
      document.body.appendChild(enlace);
      enlace.click();
      enlace.remove();

      setMensaje('✅ Backup descargado correctamente');
    } catch (err) {
      setMensaje('❌ Error al generar el backup');
    } finally {
      setCargando(false);
    }
  };

  const subirBackup = async () => {
    if (!archivo) return setMensaje('❌ Debes seleccionar un archivo .sql');

    const confirmar = window.confirm(
      '⚠️ Esto eliminará la base de datos actual y la reemplazará por la del archivo. ¿Estás seguro?'
    );
    if (!confirmar) return;

    try {
      setCargando(true);
      const formData = new FormData();
      formData.append('archivo', archivo);

      await axios.post('https://mundiemby.us.to/api/backup/upload', formData);
      setMensaje('✅ Restauración completada con éxito');
    } catch (err) {
      setMensaje('❌ Error al restaurar la base de datos');
    } finally {
      setCargando(false);
    }
  };

  return (
    <>
      <AdminMenu />
      <div style={{ paddingTop: '60px' }}>
      <h2>🔄 Sistema de Backup de Base de Datos</h2>

      <div className="acciones">
        <button onClick={descargarBackup} disabled={cargando}>
          📤 Generar y Descargar Backup Completo
        </button>

        <div className="subida">
          <input
            type="file"
            accept=".sql"
            onChange={(e) => setArchivo(e.target.files[0])}
            disabled={cargando}
          />
          <button onClick={subirBackup} disabled={cargando || !archivo}>
            📥 Subir y Restaurar Backup
          </button>
        </div>
      </div>

      {mensaje && <p className="mensaje">{mensaje}</p>}
    </div>
    </>
  );
}

export default AdminBackup;
